project_view_handler = {

    properties: {
        featureID: '',
        typeID: '',
        geojsonID: '',
        imageURLs: {
            // TODO: 
            "Bicycle Boulevard": ["bike/Bicycle%20Boulevard.jpg"],
            "Bike Lane": ["bike/Bike%20lane.JPG"],
            "Bike Route": ["bike/Bike%20route.JPG"],
            "Buffered Bike Lane": ["bike/Buffered%20bike%20lane.JPG"],
            "Shared-use Path": ["bike/Shared-use%20path.jpg"],
            "Separated Bikeway": ["bike/separated%20bikeway.JPG"],

            "Broadway": [
                "cutsheets/Broadway.jpg", 
            ],
            "CA Drive A": [
                "cutsheets/CA Drive A.jpg", 
            ],
            "CA Drive B": [
                "cutsheets/CA Drive B.jpg", 
            ],
            "CA Drive C": [
                "cutsheets/CA Drive C.jpg", 
            ],
            "CA Drive D": [
                "cutsheets/CA Drive D.jpg", 
            ],
            "CA Drive E": [
                "cutsheets/CA Drive E.jpg", 
            ],
            "CA Drive F": [
                "cutsheets/CA Drive F.jpg", 
            ],
            "Carmelita Avenue": [
                "cutsheets/Carmelita Avenue.jpg", 
            ],
            "Hillside Drive": [
                "cutsheets/Hillside Drive.jpg", 
            ],
            "Murchinson Drive": [
                "cutsheets/Murchinson Drive.jpg", 
            ],
            "Oak Grove Ave": [
                "cutsheets/Oak Grove Avenue.jpg", 
            ],
            "Rollins Road": [
                "cutsheets/Rollins Road.jpg", 
            ],
            "Trousdale Dr 1": [
                "cutsheets/Trousdale Dr 1.jpg", 
            ],
            "Trousdale Drive 2": [
                "cutsheets/Trousdale Drive 2.jpg", 
            ],


            "CrossingImprovement": [
                // "pedestrian/curb_extensions.jpg",
                // "pedestrian/rectangular_rapid_flashing_beacon.jpg",
                // "pedestrian/high_visibility_crosswalks.jpg",
                // "pedestrian/pedestrian_refuge_island.jpg",
                // "pedestrian/high-intensity_activated_crosswalk_beacon.jpg",
                // "pedestrian/pavement_markings_signs.jpg",
            ],
            "PedEnvironment": [
                // "pedestrian/street_furniture.jpg",
                // "pedestrian/pedestrian_scale_lighting.jpg",
            ],
            "SignalImprovement": [
                // "pedestrian/signal_improvements.jpg",
            ],
            "Sidewalks": [
                // "pedestrian/sidewalks.jpg",
                // "pedestrian/sidewalk_improvements.jpg",
            ],
            "SR2S_Improvement": [
            ],
        },
        type: '',
        uid: ''
    },

    onLoad: function(){
        var self = this;
        home_handler.updateLS();

        $('#content-root, #map').addClass('noswipe');
        $('body').addClass('secondary-bg');
        $('body > .image-modal').remove();

        self.properties.typeID = window.location.hash.substring(2).split('/')[1] || properties.currentType; 
        self.properties.subtypeID = window.location.hash.substring(2).split('/')[2] || properties.currentSubType; 
        self.properties.featureID = window.location.hash.substring(2).split('/')[3] || properties.currentID;



        var id = self.properties.featureID;

        mapData.selectLayer.clearLayers();
        // map.closePopup();


        if (!mapData.geoJSONData[self.properties.subtypeID][self.properties.featureID]){
            window.location.href = "#/";
        }
        else {

            properties.currentID = id;
            properties.currentType = self.properties.typeID;
            properties.currentSubType = self.properties.subtypeID;

            var item = mapData.geoJSONData[self.properties.subtypeID][id];
            console.log(item);
            self.properties.geojsonID = item.feature.properties.OBJECTID;
            if (item instanceof L.Marker || item instanceof L.Circle) {
                self.properties.type = 'marker';
                home_handler.onMarkerClick(item);
                home_handler.centerDraw(item);
            }

            else if (item instanceof L.Polyline || item instanceof L.LayerGroup){
                self.properties.type = 'polyline';
                home_handler.onPolylineClick(undefined, item);
                home_handler.centerDraw(item);
            }

            else{
                self.properties.type = 'other';
                home_handler.onPolylineClick(undefined, item);
                home_handler.centerDraw(item);
            }

            map.invalidateSize();
            self.setData();
        }
    },

    formSubmit: function(event) {

        var self = this;
        $('#submit').prop('disabled', true);
        var fd = new FormData();  

        var formData = {
            'feature_id': self.properties.geojsonID,
            'name': $('form#suggestion-submit input[name=survey-name]').val(),
            'email': $('form#suggestion-submit input[name=survey-email]').val(),

            'bike_one': $('form#suggestion-submit input[name=bike-one]').val(),
            'bike_two': $('form#suggestion-submit input[name=bike-two]').val(),
            'bike_alt': $('form#suggestion-submit [name=bike-alt]').val(),
            'bike_alt_2': $('form#suggestion-submit [name=bike-alt-2]').val(),
            'bike_alt_reason': $('form#suggestion-submit [name=bike-alt-reason]').val(),
            'corridor_one': $('form#suggestion-submit input[name=corridor-one]').val(),
            'corridor_two': $('form#suggestion-submit input[name=corridor-two]').val(),
            'corridor_alt': $('form#suggestion-submit [name=corridor-alt]').val(),
            'corridor_alt_2': $('form#suggestion-submit [name=corridor-alt-2]').val(),
            'corridor_alt_reason': $('form#suggestion-submit [name=corridor-alt-reason]').val(),

            'ped_one': $('form#suggestion-submit input[name=ped-one]').val(),
            'ped_two': $('form#suggestion-submit input[name=ped-two]').val(),
            'ped_alt_reason': $('form#suggestion-submit [name=ped-alt-reason]').val(),

            'mode': self.properties.subtypeID,
            'type': self.properties.typeID,
            'uid': self.properties.uid,
            'benefits': $('form#suggestion-submit select[name=category]').val(),
            'comment': $('form#suggestion-submit textarea[name=comment]').val()
        };

        if (typeof localStorage !== 'undefined') {
            localStorage.setItem(
                'form-submitter-name',
                formData.name
            )

            localStorage.setItem(
                'form-submitter-email',
                formData.email
            )
        }


        $.each(formData, function(key, value)
        {
            fd.append(key, value);
        });

        $.ajax({
            type: "POST",
            url: mapData.reviewsURL,
            processData: false,
            contentType: false,
            crossDomain: false,
            data: fd,
            success: function(json) {
                $('#submit').prop('disabled', false);
                if (json.error) {
                    alert('Unable to complete your request at this time.');
                } else {
                    home_handler.addLS(self.properties.typeID + self.properties.uid);
                    window.location.href = "#/step-three/" + self.properties.featureID;
                }
                var logData = formData;
                var curr_data = mapData.geoJSONData[self.properties.subtypeID][self.properties.featureID].feature.properties;
                logData['location'] = curr_data.on_street || curr_data.Location || "";
                window.properties.submittedComments.push(logData);
            },
            error: function(xhr, textStatus, errorThrown) {
                $('#submit').prop('disabled', false);
                alert('error');
            }
        });
        event.preventDefault();
    },

    getRange: function(value){
        if (value == 0){
            return 'Ineffective';
        }
        if (value == 1){
            return 'Somewhat Ineffective';
        }
        if (value == 2){
            return 'Somewhat Effective';
        }
        if (value == 3){
            return 'Effective';
        }
        if (value == 4){
            return 'Very Effective';
        }
    },

    nextProject: function(opts){
        var self = this;
        var id = parseInt(self.properties.featureID);
        // get current list index
        var order = _.findIndex(
            mapData.geoJSONList[self.properties.typeID],
            function(a) {
                return a.id === id;
            }
        ); 
        var nextID = mapData.geoJSONList[self.properties.typeID][order + 1];

        if (typeof nextID === "undefined" || !nextID){
            nextID = mapData.geoJSONList[self.properties.typeID][0];
        }

        var uri =  "#/project-view/" + nextID.typeID + '/' + nextID.subtypeID + '/' + nextID.id;
        window.location.href = uri;

    },

    previousProject: function(opts) {

        var self = this;
        var id = parseInt(self.properties.featureID);
        var order = _.findIndex(
            mapData.geoJSONList[self.properties.typeID],
            function(a) {
                return a.id === id;
            }
        ); 
        var nextID = mapData.geoJSONList[self.properties.typeID][order - 1];

        if (typeof nextID === "undefined"){
            nextID = mapData.geoJSONList[self.properties.typeID][mapData.geoJSONList[self.properties.typeID].length - 1];
        }

        var uri =  "#/project-view/" + nextID.typeID + '/' + nextID.subtypeID + '/' + nextID.id;
        window.location.href = uri;

    },

    setData: function(){
        var self = this;

        var type  = mapData.geoJSONData[self.properties.subtypeID];
        var _item =                type[self.properties.featureID];
        var data  =                                         _item.feature.properties;

        try {
            var total = _.values(type).length;
            var current = _.values(type).indexOf(_item) + 1;

        } catch (e) {
            var total = false;
            var current = false;
        }

        if (data) {
            var data_tpl = 
             $('#summary-templates')
                    .find('[data-property-subtype-id="' + self.properties.subtypeID + '"], ' 
                        + '[data-property-type-id="' + self.properties.typeID + '"]' 
                         ).last()
             || false;

            if (data_tpl.length > 0) {
                var context = data;
                context['total'] = total;
                context['current'] = current;

                try {
                    var summary = _.template(data_tpl.html())(context);
                } catch (e) {
                    console.error(e);
                    console.error(self.properties);
                    console.error(context);
                    console.error(data_tpl);
                }
                $('#project-summary').html(summary);
            }

            var form_tpl = 
                $('#input-form-templates')
                    .find('[data-property-subtype-id="' + self.properties.subtypeID + '"], '
                        + '[data-property-type-id="' + self.properties.typeID + '"]').last()
             || false;

            var submitted_once = _.where(window.properties.submittedComments, {
                feature_id: self.properties.featureID,
                type: self.properties.typeID,
                mode: self.properties.subtypeID,
            }).length > 0;

            data.submitted_once = submitted_once;

            if (form_tpl) {
                try {
                    var formdata = _.template(form_tpl.html())(data);
                } catch (e) {
                    console.error(e);
                    console.error(self.properties);
                    console.error(data);
                    console.error(form_tpl);
                }
                $('#form-target').html(formdata);

                if (typeof localStorage !== 'undefined') {
                    var name = localStorage.getItem(
                        'form-submitter-name'
                    ) || undefined;
                    var email = localStorage.getItem(
                        'form-submitter-email'
                    ) || undefined;

                    if (typeof name !== 'undefined') {
                        $("form#suggestion-submit").find('[name=survey-name]').val(name).parents('.form-group').hide();
                    }

                    if (typeof email !== 'undefined') {
                        $("form#suggestion-submit").find('[name=survey-email]').val(email).parents('.form-group').hide();
                    }
                }
            }

            // Bike data types: 
            var imageURLkeys = [];
            var class_type = data['Web_Class'] || false;

            if (class_type) {
              imageURLkeys.push(class_type);
            }

            var cutsheet_type = data['CutSheet_Name'] || false;

            if (cutsheet_type) {
              imageURLkeys.push(cutsheet_type);
            } 

            // remaining pedestrian stuff is determined by whether geojson feature
            // contains {FacilityType: 1}
            //

            // select values of 1
            var data_not_null = _.object( 
              _.filter(
                _.pairs(data), function(p){ return p[1] === 1 }
              )
            );

            // if there is a matching key, it is an image
            var intersection_keys = _.intersection(
                _.keys(self.properties.imageURLs),
                _.keys(data_not_null) 
            );

            // grab all the values for matching keys
            var values = _.values(_.pick(
                self.properties.imageURLs, 
                _.union(imageURLkeys, intersection_keys)
            ));

            var class_images = _.flatten(values);

            var images_tpl = $('#image-template').html()
            var modals_tpl = $('#image-modals').html()

            if (images_tpl) {
              try {
                  var imgs = _.template(images_tpl)({
                    fid: self.properties.featureID || 0,
                    feature: data,
                    images: _.map(class_images, function(i){
                        // fix for cutsheet thumbnails
                        return i.replace('.pdf', '.jpg');
                    }),
                  });
                  $('#project-images').html(imgs);
              } catch (e) {
                  console.error(e);
                  console.error(self.properties);
                  console.log(class_images);
                  console.error(data);
                  console.error(images_tpl);
              }
            }

            $('#image_modals').html("");
            if (modals_tpl) {
              try {
                  var imgs = _.template(modals_tpl)({
                    fid: self.properties.featureID || 0,
                    feature: data,
                    images: class_images
                  });
                  $('#image_modals').html(imgs);
              } catch (e) {
                  console.error(e);
                  console.log(class_images);
                  console.error(self.properties);
                  console.error(data);
                  console.error(modals_tpl);
              }
            }

        }

        // TODO: fix double response validation
        // if (!(self.properties.subtypeID + self.properties.uid in mapData.pvlk)){
            $('#suggestion-submit').removeClass('hidden');
        // } else {
            // $('#suggestion-submit').removeClass('hidden').html('You have already submitted a response for this project.');
        // }

    },


    events: function() {

        var self = this;
        self.onLoad();

        $('.show-popup').click(function(event) {
            var popup_id = $(this).data().popup;

            $(popup_id).modal({
                clickClose: true
            });

            return false;
        });

        $('.next-project').click(function(event) {
            var d = $(this).data() || {};
            self.nextProject(d);
            return false;
        });

        $('.previous-project').click(function(event) {
            var d = $(this).data() || {};
            self.previousProject(d);
            return false;
        });

        $('.content-close-btn').click(function(event) {
            window.location.href = "#/projects-map";
            return false;
        });


        //  TODO: fix slider
        $( ".slider" ).slider({
              value:2,
              min: 0,
              max: 4,
              step: 1,
              slide: function( event, ui ) {
                var type = $(ui.handle).parent().attr('type');
                $('input[name='+type+']').val(ui.value);
                // $('#'+type).text(project_view_handler.getRange(ui.value));
                // project_view_handler.updateScore();
              }
        });

        $("#suggestion-submit").submit(function(event) {
            self.formSubmit(event);
            event.preventDefault();
        });

        
    }
}
